import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOMServer from 'react-dom/server';

import Quill from 'quill';
import 'quill-mention';
import 'quill-mention/dist/quill.mention.css';
import 'quill/dist/quill.core.css';
import '../helpers/quillEmoji';

import debounce from 'lodash/debounce';
import each from 'lodash/each';
import filter from 'lodash/filter';
import flattenDeep from 'lodash/flattenDeep';
import pick from 'lodash/pick';

import convertFromMarkdown from '../helpers/convertFromMarkdown';
import convertToMarkdown from '../helpers/convertToMarkdown';
import getQuillToolbarFormats from '../helpers/getQuillToolbarFormats';

import QuillEditor from '../components/quillEditor';
import QuillMention from '../components/quillMention';

const QuillEditorContainer = createReactClass({
  propTypes: {
    value: PropTypes.string,
    size: PropTypes.string,
    editorClass: PropTypes.string,
    inputClass: PropTypes.string,
    toolbarClass: PropTypes.string,
    actionsClass: PropTypes.string,
    emojiPickerPosition: PropTypes.string,
    mentionPickerPosition: PropTypes.string,
    placeholder: PropTypes.string,
    ariaLabelText: PropTypes.string,
    fileUploadAriaLabel: PropTypes.string,
    shouldAutoFocus: PropTypes.bool,
    shouldAllowEmojis: PropTypes.bool,
    shouldSubmitOnEnter: PropTypes.bool,
    shouldSubmitOnCmdEnter: PropTypes.bool,
    shouldAllowUploads: PropTypes.bool,
    shouldShowSubmitButton: PropTypes.bool,
    shouldAllowMentions: PropTypes.bool,
    escKeyHandler: PropTypes.func,
    onUnload: PropTypes.func,
    onUpload: PropTypes.func,
    onPaste: PropTypes.func,
    onTyping: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    onSubmit: PropTypes.func,
    fetchMentions: PropTypes.func,
    onLoad: PropTypes.func.isRequired,
    hasToolbar: PropTypes.bool,
    id: PropTypes.string,
    shouldShowEmojiButton: PropTypes.bool,
    onUpKeyPress: PropTypes.func,
    shouldHandleUpKeyPress: PropTypes.bool,
  },

  getDefaultProps() {
    return {
      value: '',
      size: 'default',
      placeholder: '',
      ariaLabelText: '',
      fileUploadAriaLabel: '',
      editorClass: '',
      inputClass: '',
      toolbarClass: '',
      actionsClass: '',
      emojiPickerPosition: 'bottom',
      mentionPickerPosition: 'bottom',
      shouldAutoFocus: false,
      shouldAllowEmojis: false,
      shouldSubmitOnEnter: false,
      shouldSubmitOnCmdEnter: false,
      shouldAllowUploads: false,
      shouldShowSubmitButton: false,
      shouldAllowMentions: false,
      escKeyHandler: () => {},
      onUnload: () => {},
      onUpload: () => {},
      onPaste: () => {},
      onTyping: () => {},
      onBlur: () => {},
      onFocus: () => {},
      onSubmit: () => {},
      fetchMentions: () => {},
      hasToolbar: false,
      id: null,
      shouldShowEmojiButton: true,
      onUpKeyPress: () => {},
      shouldHandleUpKeyPress: false,
    };
  },

  getInitialState() {
    this.quill = React.createRef();
    this.toolbar = React.createRef();
    this.editor = null;
    this.isTyping = false;
    this.mentionsList = [];
    return {};
  },

  componentDidMount() {
    this.setupQuill();
    this.triggerOnLoad();
    this.setInitialEditorA11y();
  },

  shouldComponentUpdate() {
    return false;
  },

  componentWillUnmount() {
    const { onUnload } = this.props;
    if (onUnload) {
      onUnload(convertToMarkdown(this.editor.getContents()));
    }
    this.editor.setContents('');
    this.editor.off('text-change', this.onTextChanged);
    this.editor.off('selection-change', this.onSelectionChanged);
  },

  onUploadClicked(event) {
    const { onUpload } = this.props;
    if (onUpload) {
      onUpload(event.target.files);
      this.editor.focus();
    }
  },

  onSubmitClicked() {
    this.props.onSubmit();
  },

  onPaste(event) {
    const mention = this.editor.getModule('mention');

    if (mention.isOpen && !event.clipboardData.files.length) {
      return setTimeout(() => {
        const range = this.editor.getSelection();
        mention.onSelectionChange(range);
      });
    }
    const { onPaste } = this.props;

    if (!onPaste) return;
    onPaste(event);
  },

  onEmojiSelected(emoji) {
    const quillEditor = this.editor;
    // Bring focus incase getSelection is undefined
    quillEditor.focus();
    const { index, length } = quillEditor.getSelection();
    quillEditor.deleteText(index, length, Quill.sources.SILENT);
    quillEditor.insertEmbed(index, 'emoji', pick(emoji, ['native']), Quill.sources.USER);
    setTimeout(() => quillEditor.setSelection(index + 1), 0);
    quillEditor.focus();
  },

  onTextChanged(change, old, source) {
    this.debouncedOnChange(this);
    const { onTyping } = this.props;
    // Only trigger a typing change if it's a user action
    if (onTyping && source === 'user') {
      if (this.isTyping === false) {
        this.isTyping = true;
        onTyping(this.isTyping);
      }
      this.resetTypingTimer();
    }
  },

  onSelectionChanged(range) {
    const { onBlur, onFocus } = this.props;
    if (!range) {
      if (onBlur) onBlur();
    } else if (onFocus) onFocus();
  },

  onCompositionEnd() {
    setTimeout(() => {
      const range = this.editor.getSelection();
      const mention = this.editor.getModule('mention');
      mention.onSelectionChange(range);
    });
  },

  setupQuill() {
    if (this.quill && !this.editor) {
      const mention = this.getMentionModule();
      const toolbar = this.getToolbar();
      const {
        emojiPickerPosition,
        placeholder,
        shouldAutoFocus,
        shouldAllowEmojis,
        value,
      } = this.props;
      this.editor = new Quill(this.quill.current, {
        debug: 'warn',
        formats: this.getFormats(),
        modules: {
          toolbar,
          emoji: (shouldAllowEmojis) ? {
            emojiPickerPosition,
          } : false,
          mention,
          keyboard: {
            bindings: this.getBindings(),
          },
        },
        placeholder,
      });

      if (value) {
        this.setQuillContents(value);
      }

      if (shouldAutoFocus) {
        this.editor.focus();
        const length = this.editor.getLength();
        this.editor.setSelection(length);
      }

      this.editor.on('text-change', this.onTextChanged);

      this.editor.on('selection-change', this.onSelectionChanged);
    }
  },

  getBindings() {
    const {
      escKeyHandler,
      shouldSubmitOnEnter,
      shouldSubmitOnCmdEnter,
      shouldHandleUpKeyPress,
      onUpKeyPress,
    } = this.props;

    return {
      tab: {
        key: 9,
        handler: () => true,
      },
      shouldHandleUpKeyPress: {
        key: 38,
        handler: () => {
          const length = this.editor.getLength();
          if (length > 1 || !shouldHandleUpKeyPress) return true;
          if (shouldHandleUpKeyPress) {
            onUpKeyPress();
            return false;
          }
        },
      },
      shouldSubmitOnEnter: {
        key: 'Enter',
        shiftKey: false,
        metaKey: false,
        handler: () => {
          const emoji = this.editor.getModule('emoji');
          if (emoji && emoji.isEnabled && emoji.isVisible && emoji.selectedEmoji) {
            emoji.onSelectEmoji();
            return false;
          }
          if (!shouldSubmitOnEnter) return true;
          if (shouldSubmitOnEnter) {
            this.submitContents();
            return false;
          }
        },
      },
      shouldSubmitOnCmdEnter: {
        key: 'Enter',
        metaKey: true,
        handler: () => {
          if (!shouldSubmitOnCmdEnter) return true;
          if (shouldSubmitOnCmdEnter) {
            this.submitContents();
            return false;
          }
        },
      },
      escKeyHandler: {
        key: 'Escape',
        metaKey: false,
        handler: () => {
          const emoji = this.editor.getModule('emoji');
          if (emoji && emoji.isEnabled && emoji.isVisible) {
            emoji.disablePicker();
            return false;
          }
          if (!escKeyHandler) return true;
          if (escKeyHandler) {
            escKeyHandler();
            return false;
          }
        },
      },
    };
  },

  getToolbar() {
    const { hasToolbar } = this.props;

    if (!hasToolbar) return false;

    return { container: this.toolbar.current };
  },

  getMentionModule() {
    const { fetchMentions, mentionPickerPosition } = this.props;
    return {
      mentionDenotationChars: ['@', '＠'],
      allowedChars: /.*/s,
      defaultMenuOrientation: mentionPickerPosition,
      source: (searchTerm, renderList) => {
        if (fetchMentions) {
          fetchMentions(searchTerm, renderList);
        } else if (searchTerm.length === 0) {
          renderList(this.mentionsList, searchTerm);
        } else {
          const matches = filter(this.mentionsList, (mentionItem) => {
            if (mentionItem.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1) {
              return mentionItem;
            }
          });
          renderList(matches, searchTerm);
        }
      },
      isolateCharacter: true,
      dataAttributes: ['id', 'name', 'avatarUrl'],
      renderItem: ({ name, avatarUrl }) => `${ReactDOMServer.renderToString(<QuillMention avatarUrl={avatarUrl} name={name} />)}`,
    };
  },

  getFormats() {
    const formats = [];
    const { shouldAllowEmojis, shouldAllowMentions, hasToolbar } = this.props;

    if (shouldAllowEmojis) {
      formats.push('emoji');
    }

    if (shouldAllowMentions) {
      formats.push('mention');
    }

    if (hasToolbar) {
      const toolbarFormats = flattenDeep(getQuillToolbarFormats());
      each(toolbarFormats, toolbarFormat => formats.push(toolbarFormat));
      const nonToolbarFormats = ['code', 'code-block', 'list', 'indent'];
      each(nonToolbarFormats, toolbarFormat => formats.push(toolbarFormat));
    }

    return formats;
  },

  setQuillContents(value) {
    const { hasToolbar } = this.props;
    const shouldShowToolbar = hasToolbar;
    const html = convertFromMarkdown(value, shouldShowToolbar);
    const delta = this.editor.clipboard.convert(html);
    this.editor.setContents(delta, 'silent');
  },

  submitContents() {
    const { onSubmit, onTyping } = this.props;
    onSubmit(convertToMarkdown(this.editor.getContents()));
    this.isTyping = false;
    if (onTyping) {
      onTyping(this.isTyping);
    }
  },

  resetTypingTimer() {
    clearTimeout(this.typingTimer);

    this.typingTimer = setTimeout(() => {
      clearTimeout(this.typingTimer);
      this.isTyping = false;
      this.props.onTyping(this.isTyping);
    }, 2000);
  },

  triggerOnLoad() {
    const { onLoad, onTyping } = this.props;
    if (onLoad) {
      onLoad({
        setValue: (contentValue = '') => {
          this.setQuillContents(contentValue);
          this.editor.focus();
          const length = this.editor.getLength();
          this.editor.setSelection(length);
        },
        setMentions: (updatedMentions) => {
          this.mentionsList = updatedMentions;
        },
        setIsTyping: (isTypingValue) => {
          this.isTyping = isTypingValue;
          if (this.isTyping === false) {
            onTyping(this.isTyping);
            clearTimeout(this.typingTimer);
          } else {
            onTyping(this.isTyping);
            this.resetTypingTimer();
          }
        },
        setEnabled: (isEnabled) => {
          this.editor.enable(isEnabled);
        },
        setEditorA11y: (ariaLabelText) => {
          this.editor.root.setAttribute('aria-label', ariaLabelText);
        },
        setPlaceholder: (placeholder) => {
          this.editor.root.dataset.placeholder = placeholder;
        },
        getValue: () => convertToMarkdown(this.editor.getContents()),
        focus: () => {
          this.editor.focus();
          const length = this.editor.getLength();
          this.editor.setSelection(length);
        },
        hideMentionsList: () => {
          const mentionsModule = this.editor.getModule('mention');
          if (mentionsModule) {
            return mentionsModule.hideMentionList();
          }
        },
        hasFocus: () => this.editor.hasFocus(),
      });
    }
  },

  setInitialEditorA11y() {
    const { ariaLabelText } = this.props;
    this.editor.root.setAttribute('role', 'textbox');
    this.editor.root.setAttribute('aria-multiline', 'true');
    this.editor.root.setAttribute('aria-label', ariaLabelText);
  },

  debouncedOnChange: debounce((container) => {
    const { onChange } = container.props;
    if (onChange) {
      onChange(convertToMarkdown(container.editor.getContents()));
    }
  }, 200),

  render() {

    const {
      value,
      editorClass,
      size,
      inputClass,
      toolbarClass,
      actionsClass,
      emojiPickerPosition,
      shouldAllowUploads,
      shouldAllowMentions,
      shouldShowSubmitButton,
      shouldAllowEmojis,
      onSubmit,
      id,
      shouldShowEmojiButton,
      hasToolbar,
      fileUploadAriaLabel,
    } = this.props;

    return (
      <QuillEditor
        id={id}
        value={value}
        editorClass={editorClass}
        inputClass={inputClass}
        actionsClass={actionsClass}
        toolbarClass={toolbarClass}
        ref={{
          quill: this.quill,
          toolbar: this.toolbar,
        }}
        fileUploadAriaLabel={fileUploadAriaLabel}
        size={size}
        shouldShowToolbar={hasToolbar}
        emojiPickerPosition={emojiPickerPosition}
        shouldAllowUploads={shouldAllowUploads}
        shouldAllowMentions={shouldAllowMentions}
        shouldShowSubmitButton={shouldShowSubmitButton}
        shouldAllowEmojis={shouldAllowEmojis}
        onPaste={this.onPaste}
        onCompositionEnd={this.onCompositionEnd}
        onSubmitClicked={onSubmit}
        onUploadClicked={this.onUploadClicked}
        onEmojiSelected={this.onEmojiSelected}
        shouldShowEmojiButton={shouldShowEmojiButton}
      />
    );
  },
});

export default QuillEditorContainer;
